import React, { useState, useEffect, useRef } from "react";
import { getIcons } from "../../Constant/Constant";
import pencil from "../../../assets/Icons/pencil.svg";
import check from "../../../assets/Icons/tick.svg";
import cross from "../../../assets/Icons/wrong tick.svg";
import LeadDbService from "../../Services/LeadDbService";
import EstimateDownloadPdf from "./EstimateDownloadPdf";
import propertyService from "../../Services/PropertyService";
import { showErrorToast, showSuccessToast } from "../../Constant/Notification";
import EstimateService from "../../Services/EstimateService";

const EstimateGeneration = ({ isOpen, onClose, propertyId }) => {
  const icon = getIcons();

  const [plottedData, setPlottedData] = useState([]);
  const [estimateData, setEstimateData] = useState([]);
  const [property, setProperty] = useState({});
  const [leadData, setLeadData] = useState([]);
  const [originalLeadData, setOriginalLeadData] = useState([]);
  const [plottedFilter, setPlottedFilter] = useState([]);
  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);
  const [selectedPlot, setSelectedPlot] = useState(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedPercentage, setSelectedPercentage] = useState("");
  const [selectedSqFeetRate, setSelectedSqFeetRate] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchQuery2, setSearchQuery2] = useState("");
  const [showPdfComponent, setShowPdfComponent] = useState(false);
  const pdfComponentRef = useRef(null);
  const pdfRef = useRef(null);

  const userData = JSON.parse(localStorage.getItem("userData"));
  const employeeId = userData?.user?.employeeId || "";
  const uid = userData?.user?.uid || "";

  console.log("propertyId ", propertyId);
  console.log(employeeId, uid);

  const dropdownRef1 = useRef(null);
  const dropdownRef2 = useRef(null);

  useEffect(() => {
    const fetchPlottedData = async () => {
      if (!propertyId) {
        console.error("Property ID is missing");
        return;
      }
      
      try {
        const response = await propertyService.fetchPropertyById(propertyId);
        console.log("Response from fetchPropertyById:", response);
        if (response?.status !== 200) {
          console.error("Failed to fetch property data:", response);
          return;
          }
          const propertyData = response?.data?.[propertyId];
        console.log("Property data fetched:", response?.data?.propertyId);

        setProperty(propertyData);
        setPlottedData(propertyData?.plots || []);
        setPlottedFilter(propertyData?.plots || []);
      } catch (error) {
        console.error("Error fetching property data:", error);
      }
    };
  
    fetchPlottedData();
  }, [propertyId]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setVisible(false);
      }
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setVisible2(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const fetchLead = async () => {
    try {
      const response = await LeadDbService.leadNameAndPhone();
      setLeadData(response?.data);
   
      setOriginalLeadData(response?.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchLead();
  }, []);

  console.log("Fetching", leadData);

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    const filteredResults = plottedData.filter((plot) =>
      plot.plotNo.toLowerCase().includes(query)
    );

    setPlottedFilter(filteredResults);
  };

  const handleSearchClick = async () =>  {
    try {
      
      const body = {
        searchKey : searchQuery,
      }
      const response = await EstimateService.unitSearch(propertyId , body);
      console.log("Response from fetchPropertyById:", response);
     
      const propertyData = response?.data?.[propertyId];
      setProperty(propertyData);
      setPlottedData(propertyData?.plots || []);
      setPlottedFilter(propertyData?.plots || []);
      setShowPdfComponent(true);
      setVisible(false);
    
    } catch (error) {
      console.error("Error fetching property data:", error);
   
    }
  }
  const handleSearchChange2 = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery2(query);
    const filteredLeads = originalLeadData.filter(
      (lead) =>
        lead.name.toLowerCase().includes(query) ||
        lead.phoneNumber.toLowerCase().includes(query)
    );
    setLeadData(filteredLeads);
  };

  const handleSelect = (plot) => {
    console.log("handleSelect", plot);
    setSelectedPlot(plot);
    setSelectedSqFeetRate(plot.ratePerSqft);
    setVisible(false);
  };

  const handleSelectLead = (lead) => {
    setSelectedLead(lead);
    setVisible2(false);
  };

  const handleSaveClick = () => {
    setIsEditing(false);
  };

  const handleCancelClick = () => {
    setIsEditing(false);
  };

  const handleClose = () => {
    setSelectedPlot(null);
    setSelectedPercentage("");
    setSearchQuery("");
    setSelectedSqFeetRate("");
    setSelectedLead(null);
    onClose();
  };

  const submiteData = async () => {
    if (!selectedPlot || !selectedLead || selectedPercentage === "") {
      showErrorToast("Please select all required fields");
      return;
    }

    const bodyData = {
      propertyName: property?.name,
      leadId: selectedLead?.id,
      documentCharge: Number(property?.documentCharge),
      plotId: selectedPlot.id,
      plotNo: selectedPlot.plotNo,
      propertyId: propertyId,
      loanPercentage: Number(selectedPercentage),
      totalPlotSqft: selectedPlot?.sqft,
      createdBy: uid,
      createdByEmployeeId: employeeId,
      registrationCharge: selectedPlot?.registrationCharge,
      guidelineValue: selectedPlot?.guidlineSqftPrice,
      surveyFee: Number(property?.surveyFee),
      plotPerSqftPrice: Number(selectedSqFeetRate),
    };

    try {
      const response = await propertyService.estimateCreating(bodyData);
      console.log(response);
      if (response?.status === 200) {
        setEstimateData(response?.data);
        showSuccessToast("Estimate has be downloaded successfully");

        setTimeout(() => {
          if (pdfRef.current) {
            pdfRef.current.generatePDF();
          }
          handleClose();
        }, 500);
      }
    } catch (e) {
      console.log(e);
      showErrorToast("Failed to fetch estimate data");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-[685px] h-auto relative">
        <button
          className="absolute top-5 right-4 text-gray-600 hover:text-gray-800"
          onClick={handleClose}
        >
          ✖
        </button>
        <h2 className="text-[24px]  font-semibold text-customGreen mb-3 break-words leading-snug">
          {property?.name || "None"} : Estimate Generation
        </h2>

        <div className="flex flex-col gap-4">
          <div className="text-[16px]">Select Plot <span className="text-red-500 font-semibold  ">*</span></div>
          <input
            type="text"
            value={selectedPlot ? selectedPlot.plotNo : ""}
            onFocus={() => setVisible(true)}
            placeholder="Type Plot Number"
            className="p-2 border-2 w-1/2 rounded-md border-slate-300"
            readOnly
          />

          {visible && (
            <div
              ref={dropdownRef1}
              className="absolute max-h-48 overflow-y-auto  mt-24 w-[46%] bg-white  border-2 z-10  divide-y divide-white rounded-lg shadow"
            >
              <div className="w-full sticky px-3 py-3 top-0  bg-white ">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  placeholder="Search Lead"
                  className="w-full px-4 py-2 rounded-full text-sm border border-lightestGrayColor pr-10"
                />
                <img
                  src={icon?.searchIcon}
                  alt="search"
                  onClick={handleSearchClick}
                  className="absolute right-5 top-5 w-5 pointer-events-none"
                />
              </div>
              <ul className="py-2 text-sm text-gray-700">
                {plottedFilter.map((plot, index) => (
                  <li key={index}>
                    <div
                      onClick={() => handleSelect(plot)}
                      className="block font-primaryFont cursor-pointer px-4 py-2 hover:bg-gray-100"
                    >
                      {plot?.plotNo}
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="text-[16px]">Select Loan Percentage <span className="text-red-500 font-semibold  ">*</span></div>
          <div className="flex items-center gap-6">
            {["0", "50", "60", "70", "80", "90"].map((percentage, index) => (
              <div key={index} className="flex items-center gap-2">
                <input
                  id={`radio-${index}`}
                  type="radio"
                  name="loanPercentage"
                  value={percentage}
                  checked={selectedPercentage === percentage}
                  onChange={() => setSelectedPercentage(percentage)}
                  className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300"
                />
                <label
                  htmlFor={`radio-${index}`}
                  className="ml-2 text-[22px] font-medium text-gray-700"
                >
                  {percentage}%
                </label>
              </div>
            ))}
          </div>

          <div className="text-[16px]">Select Lead <span className="text-red-500 font-semibold  ">*</span></div>

          <input
            type="text"
            value={selectedLead ? selectedLead.name : ""}
            onFocus={() => setVisible2(true)}
            placeholder="Type Lead Name"
            className="p-2 border-2 w-1/2 rounded-md border-slate-300"
            readOnly
          />

          {visible2 && (
            <div
              ref={dropdownRef2}
              className="absolute mt-[17rem] w-[46%] bg-white  border-2 z-10 max-h-48 overflow-y-auto divide-y divide-white rounded-lg shadow"
            >
              <div className="w-full sticky px-3 top-0 py-2 bg-white ">
                <input
                  type="text"
                  value={searchQuery2}
                  onChange={handleSearchChange2}
                  placeholder="Search Lead"
                  className="w-full px-4 py-2 rounded-full text-sm border border-lightestGrayColor pr-10"
                />
                <img
                  src={icon?.searchIcon}
                  alt="search"
                  className="absolute right-5 top-5 w-5 pointer-events-none"
                />
              </div>

              <ul className="py-2 text-sm  text-gray-700">
                {leadData.map((lead, index) => (
                  <li key={index} className="border-b last:border-none">
                    <div
                      onClick={() => handleSelectLead(lead)}
                      className="flex justify-between items-center px-4 py-3 cursor-pointer hover:bg-gray-100 transition-all duration-200 rounded-md"
                    >
                      <div className="text-lg font-semibold text-gray-800">
                        {lead?.name}
                      </div>
                      <div className="text-sm text-gray-500">
                        {lead?.phoneNumber}
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="flex items-center text-[16px] mt-4">SQ Feet Rate  <span className=" ml-1 text-red-500 font-semibold ">*</span></div>
          <div className="flex items-center gap-4 justify-between">
            <div className="flex items-center gap-2">
              <input
                type="text"
                placeholder="0"
                value={selectedSqFeetRate}
                onChange={(e) => {
                  const numericValue = e.target.value.replace(/[^0-9]/g, "");
                  setSelectedSqFeetRate(numericValue);
                }}
                className="p-1 border-2 w-[50%] rounded-md border-slate-300"
                disabled={!isEditing}
              />
              <div>
                {isEditing ? (
                  <div className="flex items-center gap-3">
                    <img
                      src={check}
                      alt="Save"
                      className="w-5 h-4 cursor-pointer"
                      onClick={handleSaveClick}
                    />
                    <img
                      src={cross}
                      alt="Cancel"
                      className="w-4 h-4 cursor-pointer"
                      onClick={handleCancelClick}
                    />
                  </div>
                ) : (
                  <img
                    src={pencil}
                    alt="Edit"
                    className="w-4 h-4 cursor-pointer"
                    onClick={() => setIsEditing(true)}
                  />
                )}
              </div>
            </div>
            <button
              onClick={submiteData}
              className="bg-customGreen text-white px-4 py-2 rounded-md mt-4"
            >
              Download
            </button>
          </div>
        </div>
      </div>
      <EstimateDownloadPdf ref={pdfRef} estimateData={estimateData} />
    </div>
  );
};

export default EstimateGeneration;
